/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SelectedColumns
 */
export interface SelectedColumns {
    /**
     * 
     * @type {number}
     * @memberof SelectedColumns
     */
    positionStart: number;
    /**
     * 
     * @type {number}
     * @memberof SelectedColumns
     */
    positionEnd: number;
}

/**
 * Check if a given object implements the SelectedColumns interface.
 */
export function instanceOfSelectedColumns(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "positionStart" in value;
    isInstance = isInstance && "positionEnd" in value;

    return isInstance;
}

export function SelectedColumnsFromJSON(json: any): SelectedColumns {
    return SelectedColumnsFromJSONTyped(json, false);
}

export function SelectedColumnsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectedColumns {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'positionStart': json['positionStart'],
        'positionEnd': json['positionEnd'],
    };
}

export function SelectedColumnsToJSON(value?: SelectedColumns | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'positionStart': value.positionStart,
        'positionEnd': value.positionEnd,
    };
}

